import React from "react";
import HeaderBottom from "../assets/header-bottom-shap.png";
import TabsFlightHotal from "../components/TabsFlightHotal";
import YourBudgetFilter from "../components/YourBudgetFilter";
import PopularFilters from "../components/PopularFilters";
import Meals from "../components/Meals";
import Facilities from "../components/Facilities";
import HotelList from "../components/HotelList";
import { useTranslation } from "react-i18next";

const Hotel = () => {
    const { t } = useTranslation();
  return (
    <main className="main position-relative">
      <div className="bottom-main-shap position-absolute top-0">
        <img src={HeaderBottom} alt="" />
      </div>
      <TabsFlightHotal />
      <div className="trip-main-sec position-relative z-1 mt-md-5 mt-4 mb-md-5 mb-4">
        <div className="btn-filter-box d-lg-none ">
          <button className="btn btn-menu border-0" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExampleFilter" aria-controls="offcanvasExample">
            {t("filterTitle")}
            <i className="fas fa-bars"></i>
          </button>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12 mb-lg-0 mb-4">
              <div className="map-trip-box mb-3">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d201492.78632499743!2d72.86696184914157!3d19.015497856965077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f131!3m3!1m2!1s0x3be7b9f0b81f13ad%3A0x3c12f7681185f869!2sNavi%20Mumbai%2C%20Maharashtra!5e1!3m2!1sen!2sin!4v1754131896746!5m2!1sen!2sin" width="425" height="260" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
              </div>

                <div className="offcanvas offcanvas-start filter-box-sec" tabIndex="-1" id="offcanvasExampleFilter" aria-labelledby="offcanvasExampleLabel">
                  {/* <div class="modal-dialog modal-dialog-scrollable overflow-scroll-sec w-100"> */}
                  <div className="trip-left-sec mb-md-0 mb-4 h-auto">
                    <button type="button" className="btn-close d-lg-none d-block" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                    {/* <!--mobile filter--> */} 
                    <div className="">
                        <div className="heading">
                            <h4>{t("filterTitle")} <span>{t("showingHotels")} 120 {t("hotels1")}</span></h4>
                        </div>
                        <YourBudgetFilter />
                        <PopularFilters />
                        <Meals />
                        <Facilities />
                      </div>
                    {/* </div> */}
                </div>
              </div>

            </div>
            <div className="col-lg-8 col-md-12">
              <div className="trip-right-sec">
                  <HotelList />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Hotel;
